import styled from 'styled-components';

interface IProps {
    value?: number;
    max?: number;
    hasScoreCheckpoints?: boolean;
    hasUserIcon?: boolean;
    percentageNumber?: number;
    midLabel?: string;
    minLabel?: string;
    maxLabel?: string;
}

export const SingleBarChartComponent = styled.div`
    font-size: 14px;
    color: grey;
`;

export const Header = styled.div`
    display: flex;
    margin-bottom: 30px;
`;

export const Title = styled.div`
    color: #40596f;
    h2 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
    }
    h3 {
        font-size: 14px;
        font-weight: normal;
        margin-bottom: 0;
    }
`;

export const ValueWrapper = styled.div`
    display: flex;
    margin-left: auto;
    align-items: center;

    .scoreLabel {
        color: rgba(64, 89, 111, 0.4);
        font-size: 14px;
        font-weight: bold;
    }

    .valueSeparator {
        color: rgba(64, 89, 111, 0.4);
        font-size: 26px;
        margin: 0 8px;
    }
`;
export const ResultValue = styled.div`
    color: #00a5ac;
    font-size: 14px;
    font-weight: bold;
`;
export const SingleBarChartWrapper = styled.div`
    min-height: 65px;
`;
export const ProgressBar = styled('div')<IProps>`
    position: relative;
    width: ${(props) => props.max}%;
    height: 17px;
    border: 1px solid transparent;
    background: #eff5fb;
    border-radius: 100px;
`;
export const IconWrapper = styled('div')<IProps>`
    position: absolute;
    top: -36px;
    left: calc(${(props) => props.value}% - 30px);
    padding-top: 8px;
    :after {
        display: ${(props) => (props.hasUserIcon ? 'block' : 'none')};
        content: '';
        position: absolute;
        z-index: 10;
        top: 28px;
        left: 46%;
        height: 8px;
        border-left: 2px solid #3ebac0;
    }
`;
export const Img = styled.img`
    width: 20px;
`;
export const ActiveProgressBar = styled('div')<IProps>`
    width: ${(props) => props.value}%;
    height: 16px;
    background: linear-gradient(
        90deg,
        #cbebed 0%,
        #3ebac0 99.99%,
        #00a5ac 100%
    );
    border-radius: 100px;
`;
export const ProgressBarSub = styled('div')<IProps>`
    width: ${(props) => props.max}%;
    position: relative;
`;
export const PercentageWrapper = styled('div')<IProps>`
    padding-top: 8px;
    font-size:11px;
    :after {
        display: ${(props) => (props.hasScoreCheckpoints ? 'block' : 'none')};
        content: '';
        position: absolute;
        z-index: 10;
        top: -15px;
        left: ${(props) => props.percentageNumber}%;
        height: 20px;
        border-left: 1px dotted grey;
    }
    :before {
        display: ${(props) => (props.hasScoreCheckpoints ? 'block' : 'none')};
        content: '${(props) => props.percentageNumber}%';
        position: absolute;
        top: 8px;
        left: calc(${(props) => props.percentageNumber}% - 1%);
    }
`;
export const SubText = styled('div')<IProps>`
    font-size: 11px;
    :before {
        content: '${(props) =>
            props.minLabel || props.midLabel || props.maxLabel}';
        position: absolute;
        max-width: 90px;
        top: 8px;
        left: ${(props) =>
            (props.minLabel && '0%') || (props.midLabel && '45%')};
        right: ${(props) => props.maxLabel && '0%'};
    }
`;
